import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinalThreeService {
  private scene!: any;
  private camera!: any;
  private renderer!: any;
  private splineApp!: any;

  constructor() { }

  async initialize(container: HTMLElement, data: string): Promise<void> {
    // Lazy load Three.js and Spline Runtime
    const THREE = await import('three');
    const { Application } = await import('@splinetool/runtime');

    // Initialize Three.js scene
    this.scene = new THREE.Scene();

    // Initialize camera
    this.camera = new THREE.PerspectiveCamera(
      75,
      container.clientWidth / container.clientHeight,
      0.1,
      1000
    );
    this.camera.position.z = 5;

    // Initialize renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(container.clientWidth, container.clientHeight);
    container.appendChild(this.renderer.domElement);

    // Load Spline `.splinecode` file
    this.splineApp = new Application(this.renderer.domElement);
    this.splineApp.load(data).then(() => {
      console.log('Spline scene loaded');
    });
  }
}
